import { createSlice } from '@reduxjs/toolkit';
import {
  createPfEmployee,
  fetchAllPfEmployees,
  fetchPfEmployeeById,
  updatePfEmployee,
  deletePfEmployee
} from './pfEmployeeActions';
import { PfEmployeeState } from './pfEmployeeTypes';

const initialState: PfEmployeeState = {
  records: [],
  selectedRecord: undefined,
  loadingStates: {
    create: false,
    fetchAll: false,
    fetchById: false,
    update: false,
    delete: false
  },
  errors: {}
};

const pfEmployeeSlice = createSlice({
  name: 'pfEmployee',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createPfEmployee.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createPfEmployee.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        state.records.push(action.payload.data);
      })
      .addCase(createPfEmployee.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

      // Fetch All
      .addCase(fetchAllPfEmployees.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllPfEmployees.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.records = action.payload.data;
      })
      .addCase(fetchAllPfEmployees.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      })
      // Fetch By ID
      .addCase(fetchPfEmployeeById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchPfEmployeeById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedRecord = action.payload;
      })
      .addCase(fetchPfEmployeeById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })

      // Update
      .addCase(updatePfEmployee.pending, (state) => {
        state.loadingStates.update = true;
        state.errors.update = undefined;
      })
      .addCase(updatePfEmployee.fulfilled, (state, action) => {
        state.loadingStates.update = false;
        const index = state.records.findIndex(
          (rec) => rec.pfEmployeeId === action.payload.id
        );
        if (index !== -1) {
          state.records[index] = {
            ...action.payload.data,
            pfEmployeeId: action.payload.id
          };
        }
      })
      .addCase(updatePfEmployee.rejected, (state, action) => {
        state.loadingStates.update = false;
        state.errors.update = action.payload as string;
      })

      // Delete
      .addCase(deletePfEmployee.pending, (state) => {
        state.loadingStates.delete = true;
        state.errors.delete = undefined;
      })
      .addCase(deletePfEmployee.fulfilled, (state, action) => {
        state.loadingStates.delete = false;
        state.records = state.records.filter(
          (record) => record.pfEmployeeId !== action.payload
        );
      })
      .addCase(deletePfEmployee.rejected, (state, action) => {
        state.loadingStates.delete = false;
        state.errors.delete = action.payload as string;
      });
  }
});

export default pfEmployeeSlice.reducer;
